/**
 * Same-origin API base. Vite proxies `/v2` and `/api/*` to the Worker.
 * Only `VITE_*` public values are exposed to the browser bundle.
 */
export const API_URL = "/";

export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || "local";

export const GOOGLE_MAPS_API_KEY =
  (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined) || "";

/** External model-preview app (not dashboard). Default avoids dashboard :3003. */
export const MODEL_PREVIEW_URL =
  (import.meta.env.VITE_MODEL_PREVIEW_URL as string | undefined) ||
  "http://localhost:3004";

export const STRIPE_DASHBOARD_TEST =
  import.meta.env.VITE_STRIPE_DASHBOARD_TEST === "1" ||
  import.meta.env.VITE_STRIPE_DASHBOARD_TEST === "true";
